export default function NormalButton({label,onClick,gabStart=false, gabEnd=false, isDisabled=false, color=false,full=false}){

    return (
        <div className={`inline-block h-[48px] leading-[48px] text-center bg-darkBlue text-white px-[32px] rounded-[8px] cursor-pointer select-none font-[600] text-[18px] ${gabStart ? 'ms-[10px]' : ''} ${gabEnd ? 'me-[10px]' : ''} ${isDisabled ? '!bg-grey-300 pointer-events-none' : ''} ${color} ${full ? '!w-full' : ''}`} onClick={onClick}>
            {label}
        </div>
    )
}